export const createDebounce = global => (callback, context = window) => {
  let debouncedCallback = (...args) => {
    return new Promise((resolve) => {
      debouncedCallback.clear();
      debouncedCallback._isInProgress = true;
      debouncedCallback._resolves.push(() => resolve());
      debouncedCallback._debounceId = global.requestAnimationFrame(() => debouncedCallback.flush(...args));
    });
  };

  debouncedCallback._debounceId = null;
  debouncedCallback._isInProgress = false;
  debouncedCallback._resolves = [];

  debouncedCallback.callImmediate = (...args) => {
    callback.apply(context, args);
  };

  debouncedCallback.flush = (...args) => {
    if (!debouncedCallback._isInProgress) { return; }

    debouncedCallback.callImmediate(...args);
    debouncedCallback._resolves.forEach(resolve => {
      resolve();
    });
    debouncedCallback._resolves = [];
    debouncedCallback.clear();
  };

  debouncedCallback.clear = () => {
    if (!debouncedCallback._isInProgress) { return; }

    global.cancelAnimationFrame(debouncedCallback._debounceId);
    debouncedCallback._debounceId = null;
    debouncedCallback._isInProgress = false;
  };

  return debouncedCallback;
};

export const debounce = createDebounce(window);
